/**
 * TypeScript types for i18n translations
 */

/**
 * Supported languages in the application
 */
export const supportedLanguages = ['en', 'ru', 'uz', 'cril'] as const

/**
 * Type representing a supported language code
 */
export type SupportedLanguage = (typeof supportedLanguages)[number]

/**
 * Translation resource structure (nested key-value pairs)
 */
export interface TranslationResource {
  [key: string]: string | TranslationResource
}

/**
 * Resources structure for all languages
 */
export interface Resources {
  [language: string]: {
    translation: TranslationResource
  }
}

/**
 * Language option for display in UI
 */
export interface LanguageOption {
  code: SupportedLanguage
  name: string // English name
  nativeName: string // Native language name
  flag?: string // Optional flag emoji or icon
}

/**
 * Language preference stored in localStorage
 */
export interface LanguagePreference {
  locale: SupportedLanguage
  timestamp: number
}

/**
 * Native names for each supported language
 */
export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  ru: 'Русский',
  uz: "O'zbekcha",
  cril: 'Кирилча',
}

/**
 * Language options array for UI components
 */
export const languageOptions: LanguageOption[] = supportedLanguages.map(
  (code) => ({
    code,
    name: code.toUpperCase(),
    nativeName: languageNames[code],
  })
)
